import {AfterViewInit, Component, OnInit} from '@angular/core';
import {User} from '../shared/data-objects/user';
import {LoginService} from '../shared/services/login.service';
import {SelectItem} from 'primeng/primeng';
import {HydrantLogService} from '../shared/services/hydrantlog.service';
import {HydrantLog} from '../shared/data-objects/hydrant-log';
import {FormControl} from '@angular/forms';
//import * as moment from 'moment'
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-hydrant-log',
  templateUrl: './hydrant-log.html',
  styleUrls: ['./hydrant-log.css']
})
export class HydrantLogComponent implements OnInit , AfterViewInit {
  logs: HydrantLog[];
  noLogFound: boolean;
  isRequesting: boolean;
  userRoles: SelectItem[];
  accountNumber: string;
  accountNoControl: FormControl;
  permitNoControl: FormControl;
  permitNumber: string;
  registrationNoControl: FormControl;
  registrationNumber: string;
  monthControl: FormControl;
  month: string;
  private user: User;

  constructor(private hydrantLogService: HydrantLogService, private loginService: LoginService, public datepipe:DatePipe) {
    this.accountNoControl = new FormControl('');
    this.permitNoControl = new FormControl('');
    this.registrationNoControl = new FormControl('');
    this.monthControl = new FormControl('');
    this.datepipe= new DatePipe('en-US')
  }
  ngAfterViewInit(): void {
  }
  ngOnInit() {
    this.user = this.loginService.getUser();
    this.accountNumber = this.user.userRole === 'User' ? this.user.accountNumber : '';
    this.permitNumber = '';
    this.registrationNumber = '';
    this.month = '';
    this.refresh();
    this.loginService.refreshToken();
  }

  get isTechCSOUserLoggedIn(): boolean {
    return this.loginService.isSystemAdminUserLoggedIn() ||
      this.loginService.isAdminUserLoggedIn() ||
      this.loginService.isTechCSOUserLoggedIn();
  }
  refresh() {
    this.isRequesting = true;
    if(this.month !==''){
    //this.month=moment(this.month).format('MMM-YYYY')
    this.month=this.datepipe.transform(this.month,'MMM-yyyy')
    }
    const user: User = this.loginService.getUser();
    this.hydrantLogService.getMyLogs(user, this.accountNumber, this.permitNumber,
      this.registrationNumber, this.month).subscribe((logs: HydrantLog[]) => {
      this.isRequesting = false;
      if (logs == null || logs.length === 0) {
        this.logs = [];
        this.noLogFound = true;
      } else {
        this.logs = logs;
        for (let i = 0; i < this.logs.length; i++) {
          this.logs[i] = new HydrantLog(this.logs[i]);
        }
         this.logs.map(x=>{
           //x.createdDate = moment(x.createdDate).format('DD/MM/YYYY')
           x.createdDate= this.datepipe.transform(x.createdDate,'dd/MM/yyyy')
         })

        this.noLogFound = this.logs.length <= 0;
      }
    }, err => {
      this.isRequesting = false;
      this.logs = [];
      this.noLogFound = true;

    });
  }
  get isAccountControlVisible(): boolean {
    return this.loginService.isSystemAdminUserLoggedIn() ||
      this.loginService.isAdminUserLoggedIn() ||
      this.loginService.isTechCSOUserLoggedIn();
  }
  get monthOptions(): SelectItem[] {
    return [{label: 'Please select...', value: ''}, {label: 'Jan', value: 'January'},
      {label: 'Feb', value: 'February'},
      {label: 'Mar', value: 'March'},
      {label: 'Apr', value: 'April'},
      {label: 'May', value: 'May'},
      {label: 'Jun', value: 'June'},
      {label: 'Jul', value: 'July'},
      {label: 'Aug', value: 'Aug'},
      {label: 'Sep', value: 'September'},
      {label: 'Oct', value: 'October'},
      {label: 'Nov', value: 'November'},
      {label: 'Dec', value: 'December'}];
  }
  downloadExcelFromAssets() {
    const link = document.createElement('a');
    link.href = 'assets/LOG_SHEET_TEMPLATE.xlsx';
    link.download = 'LOG_SHEET_TEMPLATE.xlsx';
    link.click();
  }
}



// WEBPACK FOOTER //
// ./src/app/hydrant-log/hydrant-log.ts